import { useLocation, useParams } from 'react-router-dom';
import { useMemo } from 'react';
import { useReport } from '../../../../../api/hooks/useReport';
import { useSources } from '../../../../../api/hooks/useSources';
import { useAdesioneMercatoDettaglio } from '../../../../../api/hooks/useAdesioneMercatoDettaglio';
import ContainerAdesioneMercatiDettaglio from '../../../../../components/report/listaDriverPage/adesione-mercati/adesione-mercati-dettaglio/ContainerAdesioneMercatiDettaglio';
import BannerAdesioneMercatiDettaglio from '../../../../../components/report/listaDriverPage/adesione-mercati/adesione-mercati-dettaglio/BannerAdesioneMercatiDettaglio';
import { useEventsSearch } from '../../../../../api/hooks/useEventsSearch';

const DettaglioAdesioneMercatiPage = () => {
  const { driverRoute } = useParams<{ driverRoute: string }>();
  const location = useLocation();
  const { id, driverId, key } = location.state || {};

  const { report, loading: loadingReport, error: errorReport } = useReport(id);
  const { elements, loading: loadingElements, error: errorElements } = useAdesioneMercatoDettaglio(id, driverId, key);    
  const { sources, loading: loadingSources, error: errorSources } = useSources(id, driverId, key);
  const intermediario = elements;
  const isLoading = loadingReport || loadingElements || loadingSources; 
  const hasError = errorReport || errorElements || errorSources; 


const payload = useMemo(() => ({
  report_id: id,
  element_id: key,
}), [id, key]);

const { events} = useEventsSearch(payload);


  if (isLoading) {
    return (
      <div className="flex items-center justify-center h-screen">
        <div className="w-20 h-20 border-[6px] border-gray-300 border-t-textPrimary rounded-full animate-spin" />
      </div>
    );
  }

  if (hasError) {
    return <div className="p-6 text-red-600">Errore nel caricamento dei dati</div>;
  }
  
  return (
    <div className="flex flex-col bg-gray-50">
      <BannerAdesioneMercatiDettaglio
        report={report}
        title={driverRoute!} 
        intermediario={intermediario} 
        reportId={id}
        driverId={driverId}
      />
      <div className="px-8 lg:px-16 py-8">
        <ContainerAdesioneMercatiDettaglio
        intermediario={intermediario} 
        title={driverRoute!}
        driverRoute={driverRoute!} 
        listaMercati={[]}
        id={id}
        driverId={driverId}
        intermediarioId={key}
        sources={sources}
events={events}
      />
      </div>
    </div>
  );
};

export default DettaglioAdesioneMercatiPage;